
import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: 'CategoryTemplateDescription',

  computed: {
    replaceKeys: function () {
      return this?.externalData?.CategoryTemplateDescription?.replaceKeys || {}
    },

    text: function () {
      if (Object.keys(this.replaceKeys).length <= 0) {
        return this?.externalData?.CategoryTemplateDescription || this.values?.text || ""
      }
      // метод замены Города, если требуется
      let text = this.values?.text || "";
      Object.keys(this.replaceKeys).map((key) => {
        const countWord = (text || "").split(key).length;
        for (let i = 0; i < countWord; i++) {
          text = (text || "").replace(key, this.replaceKeys[key]);
        }
      });

      text = text.replace('city[]', this.cityUser);

      return text
    },

    cityUser: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name
    },
  }
});
